import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from '@ff/auth';
import * as i2 from '@angular/router';
import { Validators } from '@angular/forms';

class GuestGuard {
    constructor(authService) {
        this.authService = authService;
        this._authService = authService;
    }
    canActivate(route, state) {
        return !this._authService.isLoggedIn().getValue();
    }
}
GuestGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: GuestGuard, deps: [{ token: i1.AuthService }], target: i0.ɵɵFactoryTarget.Injectable });
GuestGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: GuestGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: GuestGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.AuthService }]; } });

class LoggedInGuard {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    canActivate(route, state) {
        return this.authService.isLoggedIn().getValue() ? true : this.router.parseUrl('/');
    }
}
LoggedInGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: LoggedInGuard, deps: [{ token: i1.AuthService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
LoggedInGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: LoggedInGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: LoggedInGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.AuthService }, { type: i2.Router }]; } });

function equals(source) {
    return (control) => {
        let value = '';
        if (control.parent && control.parent.get(source)) {
            value = control.parent.get(source).value;
        }
        return value !== control.value ? { 'equals': { valid: false } } : null;
    };
}

function password() {
    return Validators.pattern(/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/);
}

class CoreModule {
}
CoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: CoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: CoreModule });
CoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: CoreModule, providers: [
        LoggedInGuard,
        GuestGuard
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: CoreModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        LoggedInGuard,
                        GuestGuard
                    ],
                    declarations: [],
                    exports: []
                }]
        }] });

// Guards

/**
 * Generated bundle index. Do not edit.
 */

export { CoreModule, GuestGuard, LoggedInGuard, equals, password };
